import { UseQueryOptions, useQuery } from "react-query";
import { ChartData, SocialFollower } from "../types";
import { http } from "./http";

export function useTotalFollowers(ops?: UseQueryOptions<SocialFollower[]>) {
  return useQuery<SocialFollower[]>({
    queryKey: ["followers"],
    queryFn: () => http("/api/my-social/total-followers"),
    ...ops
  });
}

export function useChartInteractions(ops?: UseQueryOptions<ChartData[]>) {
  return useQuery<ChartData[]>({
    queryKey: ["interactions"],
    queryFn: () => http("/api/my-social/chart-interactions"),
    ...ops
  });
}